/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
/* eslint-disable import/extensions */
import { END } from "redux-saga";
import { loadSelf } from "@fdn/profile_store";
import Env from "Consts/env";
import cookie from "cookie";
import dynamic from "next/dynamic";
import { useState } from "react";
import Head from "next/head";
import { wrapper } from "@/Store/index";
import { loadCategoryDesktop } from "@/Store/category_desktop_store/lib/actions";

const Layout = dynamic(
	() => import("Containers/layout"),
	{ ssr: false },
);

const Desktop = dynamic(
	() => import("./desktop"),
	{ ssr: false },
);
const Mobile = dynamic(
	() => import("./mobile"),
	{ ssr: false },
);

const PrivacyPolicy = (props) => {

	const data = props;
	const [show, setShow] = useState(false);
	const { query: { device } } = data;

	return (

		<>
			<Head>
				<link rel="preconnect" href="https://fonts.googleapis.com" />
				<link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
				<link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&family=Work+Sans:wght@600&display=swap" rel="stylesheet" />
			</Head>
			<Layout
				home
				title="Femaledaily"
				metaTitle="Story"
				typeNavbarSecondary="type-3"
				titleNavbar="Story"
				ismobile={data.isMobile}
				self={data.getStoreSelf}
				categoryDesktop={data && data.storeCategoryDesktop}
				device={device}
				isShowSecondaryNav={false}
			>
				{data.isMobile
					? (
						<Mobile
							show={show}
							setShow={setShow}
							CategoryData={data.CategoryData}
							device={device}
						/>
					) : (
						<Desktop
							show={show}
							setShow={setShow}
							CategoryData={data.CategoryData}
						/>
					)}
			</Layout>

		</>
	);

};

const getPopupCategory = async () => {

	const options = {
		method: "GET",
		headers: {
			...Env.HEADERS,
			"content-type": "application/json",
		},
	};
	const url = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/popupCategory`;
	const resc = await fetch(url, options);

	const get = await resc.json();
	return get;

};

export const getServerSideProps = wrapper.getServerSideProps(
	async ({ store, req, query }) => {

		let userAgent;
		let cookies;
		let authorization = null;

		if (req) {

			// if you are on the server and you get a "req" property from your context
			userAgent = req.headers["user-agent"]; // get the user-agent from the headers

		} else {

			// if you are on the client you can access the navigator from the window object
			userAgent = navigator.userAgent;

		}

		const isMobile = Boolean(
			userAgent.match(
				/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
			),
		);

		const isServer = !!req;

		if (req.headers.cookie) {

			cookies = cookie.parse(req.headers.cookie);
			authorization = cookies.token;

		}

		if (authorization) {

			await store.dispatch(
				loadSelf({
					payload: {
						api_env: process.env.NEXT_PUBLIC_NODE_ENV,
						env: Env.HEADERS,
						Authorization: authorization,
						is_server: isServer,
						is_allo: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON",
					},
				}),
			);

		}

		await store.dispatch(
			loadCategoryDesktop({
				payload: {
				},
			}),
		);

		const fetchPopUpCat = await getPopupCategory();

		const getPopUpCat = fetchPopUpCat && typeof fetchPopUpCat.data !== "undefined"
			? fetchPopUpCat.data
			: null;

		store.dispatch(END);
		await store.sagaTask.toPromise();

		const categoryNavigationDesktop = [];
		const brands = {
			id: 200,
			name: "Brands",
			slug: "brands",
			items: [],
		};

		const getStoreSelf = store.getState().storeSelf && typeof store.getState().storeSelf.data !== "undefined"
			? store.getState().storeSelf
			: null;

		const getStoreCategoryDesktop = store.getState().storeCategoryDesktop.data && typeof store.getState().storeCategoryDesktop.data.data !== "undefined"
			? store.getState().storeCategoryDesktop.data
			: null;

		getStoreCategoryDesktop
		&& getStoreCategoryDesktop.data[0]
		&& getStoreCategoryDesktop.data[0].children_data
		&& getStoreCategoryDesktop.data[0].children_data.filter((val) => val.include_in_menu === "1").map((item) => {

			categoryNavigationDesktop.push({
				id: item.entity_id,
				name: item.category_name,
				slug: item.category_path,
				items: item.children_data.length > 0
					? item.children_data.map((child) => ({
						id: child.entity_id,
						name: child.category_name,
						slug: child.category_path,
						items: child.children_data.length > 0
							? child.children_data.map((childs) => ({
								id: childs.entity_id,
								name: childs.category_name,
								slug: childs.category_path,
								items: childs.children_data.length > 0
									? childs.children_data.map((lastChilds) => ({
										id: lastChilds.entity_id,
										name: lastChilds.category_name,
										slug: lastChilds.category_path,
									})) : [],
							})) : [],
					})) : [],
			});

		});
		categoryNavigationDesktop.splice(1, 0, brands);

		return {
			props: {
				query,
				isMobile,
				getStoreSelf,
				storeCategoryDesktop: categoryNavigationDesktop || null,
				CategoryData: getPopUpCat,
			}, // will be passed to the page component as props
		};

	},
);

export default PrivacyPolicy;
